import type {
  PapiDeviation,
  PapiGallection,
  PapiUser,
} from '@wix/da-papi-types';
import { GallectionType } from '../../types/gallection';
import {
  stashFolderSchema,
  collectionFolderSchema,
  galleryFolderSchema,
  stashListSchema,
  collectionListSchema,
  galleryListSchema,
  gallectionListSchema,
} from './schemas/folder';
import { normalize } from '.';
import { deviationListSchema, deviationSchema } from './schemas/deviation';
import { userListSchema, userSchema } from './schemas/user';

export function getGallectionSchema(gallection: PapiGallection) {
  switch (gallection.type) {
    case GallectionType.STASH:
      return stashFolderSchema;
    case GallectionType.PRIVATE_COLLECTION:
    case GallectionType.COLLECTION:
      return collectionFolderSchema;
    case GallectionType.GALLERY:
    default:
      return galleryFolderSchema;
  }
}
export function getGallectionListSchema(gallections: PapiGallection[]) {
  switch (gallections[0]?.type) {
    case GallectionType.STASH:
      return stashListSchema;
    case GallectionType.PRIVATE_COLLECTION:
    case GallectionType.COLLECTION:
      return collectionListSchema;
    case GallectionType.GALLERY:
    default:
      return galleryListSchema;
  }
}

export function normalizeGallection(gallection: PapiGallection) {
  const schema = getGallectionSchema(gallection);
  const { entities } = normalize(gallection, schema);
  return entities;
}

export function normalizeGallections(gallections: PapiGallection[]) {
  const schema = getGallectionListSchema(gallections);
  const { entities, result } = normalize<PapiGallection[], any, number[]>(
    gallections,
    schema
  );
  return { entities, result };
}

// normalize mixed PapiGallection array
export function normalizeGallectionsMixed(gallections: PapiGallection[]) {
  const { entities, result } = normalize<PapiGallection[], any, number[]>(
    gallections,
    gallectionListSchema
  );
  return { entities, result };
}

export function normalizeDeviation(deviation: PapiDeviation) {
  const { entities } = normalize(deviation, deviationSchema);
  return entities;
}

export function normalizeDeviations(deviations: PapiDeviation[]) {
  const { entities, result } = normalize<PapiDeviation[], any, number[]>(
    deviations,
    deviationListSchema
  );
  return { entities, result };
}

export function normalizeUser(user: PapiUser) {
  const { entities } = normalize(user, userSchema);
  return entities;
}

export function normalizeUsers(users: PapiUser[]) {
  const { entities, result } = normalize<PapiUser[], any, number[]>(
    users,
    userListSchema
  );
  return { entities, result };
}
